import { cn } from "./utils";

interface BackgroundPatternProps extends React.HTMLAttributes<HTMLDivElement> {
  pattern?: "dots" | "grid";
  dotSize?: number;
  gridSize?: number;
}

export function BackgroundPattern({
  pattern = "dots",
  dotSize = 1.5,
  gridSize = 24,
  className,
  ...props
}: BackgroundPatternProps) {
  return (
    <div
      className={cn("absolute inset-0 z-0 pointer-events-none overflow-hidden", className)}
      {...props}
    >
      {pattern === "dots" && (
        <div 
          className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-ink)_var(--dot-size),transparent_var(--dot-size))]"
          style={{
            backgroundSize: `${gridSize}px ${gridSize}px`,
            opacity: 0.1,
            "--dot-size": `${dotSize}px`
          } as React.CSSProperties}
        />
      )}
      {pattern === "grid" && (
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, var(--color-ink) 1px, transparent 1px), linear-gradient(to bottom, var(--color-ink) 1px, transparent 1px)`,
            backgroundSize: `${gridSize}px ${gridSize}px`,
            opacity: 0.05,
          }}
        />
      )}
       <div className="absolute inset-0 bg-background pointer-events-none [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]" />
    </div>
  );
}
